import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  Alert,
  Paper
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import TivraLogo from '../assets/tivra_logo.svg';
import { Link as RouterLink } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setMessage('');
      setError('');
      setLoading(true);
      await resetPassword(email);
      setMessage('Check your inbox for further instructions');
    } catch (error) {
      setError('Failed to reset password: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#F8F9FA',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <RouterLink to="/"> {/* Wrap the logo with RouterLink */}
          <img src={TivraLogo} alt="Tivra Logo" style={{ marginBottom: '20px', width: '200px' }} />
        </RouterLink>
      </Box>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 400,
          borderRadius: 2
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 3,
            fontWeight: 600,
            textAlign: 'center'
          }}
        >
          Sign In
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {message && <Alert severity="success">{message}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{ 
              textTransform: 'none',
              py: 1.5,
              backgroundColor: '#2D68FE',
            }}
          >
            Reset Password
          </Button>
        </form>

        <Box sx={{ 
          mt: 2,
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Link 
            href="/login" 
            variant="body2"
            sx={{ 
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Already have an account? Sign In
          </Link>
          <Link 
            href="/signup" 
            variant="body2"
            sx={{ 
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Create an account
          </Link>
        </Box>

      </Paper>
    </Box>
    // <Box
    //   component="form"
    //   onSubmit={handleSubmit}
    //   sx={{
    //     maxWidth: 400,
    //     mx: 'auto',
    //     p: 3,
    //     display: 'flex',
    //     flexDirection: 'column',
    //     gap: 2
    //   }}
    // >
    //   <Typography variant="h5" component="h1" gutterBottom>
    //     Password Reset
    //   </Typography>

    //   {error && <Alert severity="error">{error}</Alert>}
    //   {message && <Alert severity="success">{message}</Alert>}

    //   <TextField
    //     label="Email"
    //     type="email"
    //     value={email}
    //     onChange={(e) => setEmail(e.target.value)}
    //     required
    //     fullWidth
    //   />

    //   <Button
    //     type="submit"
    //     variant="contained"
    //     disabled={loading}
    //     fullWidth
    //   >
    //     Reset Password
    //   </Button>

    //   <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
    //     <Link href="/login" variant="body2">
    //       Back to Sign In
    //     </Link>
    //   </Box>
    // </Box>
  );
}
